import {compute_invoice} from '@/providers/context'

export var issuer = {
  name: 'Enkronos OÜ',
  address: 'Keemia tn 4',
  zip: 'Ee10616',
  city: 'Tallinn',
  country: 'Estonia',
  // phone: '++386 5 5555 550',
  // email: 'info@enkronos.com',
  vat: 'EE102151239'
};

const invoices = {
  methods: {
    compute (invoice) {
      return compute_invoice(invoice);
    },
  },
};
export default invoices;


// WEBPACK FOOTER //
// ./src/sections/billings/invoices.js